import UF from '@/app/arch/enums/UF';
import CnpjFilter from '@/app/arch/filters/CnpjFilter';
import CpfFilter from '@/app/arch/filters/CpfFilter';
import DateMixin from '@/app/arch/mixins/DateMixin';

export default {
  mixins: [DateMixin],
  computed: {
    isLoading() {
      return this.loading;
    },
    handleDisplay() {
      return (key) => ({
        [this.disabled(key) ? 'readonly' : 'disabled']: true,
      });
    },
    disabled() {
      return (key) => this.payload && this.payload[key];
    },
    getProperty() {
      return (key) => (
        this.hasValue(key)
          ? this.prepareValueKey(key)
          : ''
      );
    },
    prepareValueKey() {
      return (prop = '') => {
        if (prop.includes('.')) {
          let value = '';
          prop.split('.')
            .forEach((key) => {
              value = value ? value[key] : this.value[key];
            });
          return value;
        }
        return this.value ? this.value[prop] : '';
      };
    },
    hasValue() {
      return (key) => {
        if (!this.value) return false;
        const value = this.value[key];
        if (typeof value === 'undefined' || value === null || value === '') {
          return false;
        }
        return true;
      };
    },
    setState() {
      return (key) => this.getState(
        this.getProperty(key),
      );
    },
    getState() {
      return (key) => {
        const uf = this.states.find(
          (state) => state.value === key,
        );

        return uf ? uf.text : '';
      };
    },
    getCep() {
      return (key) => this.formatCep(
        this.getProperty(key),
      );
    },
    getCpf() {
      return (key) => this.formatCpf(
        this.getProperty(key),
      );
    },
    getCnpj() {
      return (key) => this.formatCnpj(
        this.getProperty(key),
      );
    },
    getDateOfBirth() {
      return (key, format = 'DD/MM/YYYY') => {
        const date = this.getProperty(key);
        if (date) {
          return this.formatDate(
            date,
            format,
          );
        }
        return '';
      };
    },
    getCurrency() {
      return (key) => this.formatCurrency(
        this.getProperty(key),
      );
    },
  },
  methods: {
    formatCep(cep) {
      if (cep) {
        return cep.replace(/(\d{5})(\d{3})/g, '$1-$2');
      }

      return '';
    },
    formatCpf(cpf) {
      return CpfFilter(cpf);
    },
    formatCnpj(cnpj) {
      return CnpjFilter(cnpj);
    },
    formatCurrency(value) {
      const currencyToNumber = Number(parseFloat(value) || 0);
      const currency = currencyToNumber.toFixed(2).split('.');
      currency[0] = this.prefix.concat(' ')
        .concat(currency[0].split(/(?=(?:...)*$)/).join('.'));
      return currency.join(',');
    },
  },
  data: () => ({
    states: UF,
    prefix: 'R$',
  }),
};
